﻿    var data;

    function updateUrl(event) {
        var history = window.History;
        var stateData = $.extend({}, data);
        stateData.image = $(event.target.currSlide.content).data('image-id');
        history.pushState(stateData, $('title').html(), location.pathname + '?' + $.param(stateData));
        var movePosition = 0;
        var nextArticle = event.target.slider.parents('[data-more-article]');
        if (nextArticle.text() == '') {
            movePosition = event.target.slider.parents('.main-content-wrapper').find('#gallery-container').offset().top;
            if (movePosition > 237)
                movePosition = 237;
        } else {
            movePosition = nextArticle.find('.main-content-wrapper').find('#gallery-container').offset().top;
        }
        $("html, body").animate({ scrollTop: movePosition }, "slow");
    }

    function loadGallery() {
        var sliders = $("[data-car-launch-slider-gallery]");
        if (sliders.length == 0)
            return;

        sliders.each(function (index, element) {
            var $element = $(element);
            if ($element.data('royalSlider') != null)
                return;
            var slider = $element.royalSlider({
                arrowsNavAutoHide: false,
                imageScaleMode: 'fit-if-smaller',
                imageScalePadding: 0,
                autoScaleSlider: true,
                autoScaleSliderWidth: 750,
                autoScaleSliderHeight: 563,
                globalCaption: true,
                controlNavigationSpacing: 0,
                controlNavigation: "none",
                loop: true,
                numImagesToPreload: 1,
                keyboardNavEnabled: true,
                usePreloader: false,
                slidesSpacing: 0,
                minSlideOffset: 0,
                thumbs: {
                    arrowsAutoHide: true,
                    spacing: 0
                }
            });

            var sliderData = slider.data('royalSlider');
            data = sliders.data('car-launch-slider-query-string');
            if (data.image) {
                for (var i = 0; i < sliderData.slides.length; i++) {
                    var slide = sliderData.slides[i];
                    if (slide.content.data('image-id') == data.image) {
                        // as per http://help.dimsemenov.com/discussions/problems/1373-gotosilent-version-93
                        sliderData.st.transitionSpeed = 0;
                        sliderData.goTo(slide.id);
                        setTimeout(function () {
                            sliderData.st.transitionSpeed = 600;
                        }, 10);
                    }
                }
            }
            sliderData.ev.on('rsAfterSlideChange', updateUrl);
            window.gallerySliderData = sliderData;
            var siblings = $element.siblings('[data-slider-caption-container]');
            var caption = $element.find('.rsGCaption');
            caption.appendTo(siblings);
        });
        $('.rsNav.rsThumbs.rsThumbsHor').attr("style", "height:auto");
    }

    export function setupCarLaunchGallery(){
        if($('[data-car-launch-gallery]').length)
        {
        window.loadGallery = loadGallery;
        loadGallery();
        }
    }